import React, { useState, useEffect } from 'react';

import Dropdown from '../global/Dropdown'

import {DDOptions, SearchAndFilterParams} from  '@/interfaces/LockerManagement'

import  '@/css/searchandfilter.scss';
import { BuildPath } from  '@/helpers/Paths';

interface SearchAndFilterProps {
    className?:string
    placeholder: string
    ddPlaceholder?: string
    ddOptions?: DDOptions[]
    prevValues?: SearchAndFilterParams,
    hasDropDown?: boolean
    isLoading?: boolean;
    onSearchSubmit: ({dropdownValue, searchTerm}:{dropdownValue?: number | string, searchTerm?: string}) => void
}

const SearchAndFilter = ({className, placeholder, ddPlaceholder, onSearchSubmit, ddOptions, prevValues={}, hasDropDown=true, isLoading=false}:SearchAndFilterProps) => {
    const [dropdownValue, setDropdownValue] = useState<number | string>();
    const [searchTerm, setSearchTerm] = useState<string>(prevValues.searchTerm ? prevValues.searchTerm : '');
    const [historicalSearchTerm, setHistoricalSearchTerm] = useState<string>(prevValues.searchTerm ? prevValues.searchTerm : '');
    const [isSearch, setIsSearch]  = useState<boolean>(false)

    useEffect(() => {
        onSearchSubmit({dropdownValue, searchTerm})
    }, [dropdownValue])

    // only display search loading spinner if search has been clicked
    // if search has been clicked and loading resolves remove the search flag
    useEffect(() => {
        if (isSearch && !isLoading) {
            setIsSearch(false)
        }
    },[isLoading])

    function getLabelFromValue(dropdownValue: string | number) {
        const option =  ddOptions.find(element => JSON.stringify(element.value) === JSON.stringify(dropdownValue))
        return option ? option.label : 'null'
    }

    function performSearch() {
        setHistoricalSearchTerm(searchTerm);
        onSearchSubmit({searchTerm, dropdownValue});
        setIsSearch(true);
    }

    return (
        <div id="react-search-and-filter" className={`search-and-filter-wrapper${className ? ` ${className}` : ''}`}>
            {hasDropDown && <Dropdown
                className={'locker-management-dropdown'}
                options={ddOptions}
                defaultValue={prevValues && (prevValues.filter || prevValues.filter === 0) 
                    ? getLabelFromValue(prevValues.filter) 
                    : undefined
                }
                setValue={setDropdownValue}
                placeholder={ddPlaceholder}
            />}
            <div className="locker-management-search-field-wrapper">
                <input 
                    type="text"
                    aria-label={placeholder}
                    className="locker-management-search-field"
                    placeholder={placeholder}
                    onChange={e => setSearchTerm(e.target.value)}
                    value={searchTerm}
                    onKeyDown={(e:React.KeyboardEvent) => {
                        if(e.key === 'Enter') {
                            performSearch();
                        }
                    }}
                />
                { searchTerm && 
                    <button 
                        aria-label="clear search field"
                        onClick={()=> {
                            setSearchTerm('')
                            onSearchSubmit({searchTerm: ''})
                            setHistoricalSearchTerm('');
                        }}
                    >
                    X
                    </button>
                }
                
            </div>
           

            <button
                className="search-button"
                disabled={(!searchTerm && !historicalSearchTerm) || searchTerm === historicalSearchTerm}
                onClick={() => {
                    performSearch();
                }}
            >
                {isSearch ? <img src={`${BuildPath()}/images/userupload/rolling.svg`} alt="loading-spinner"/>: 'Search'}
            </button>
        </div>
    )
}

export default SearchAndFilter;